module.exports = __webpack_public_path__ + "static/media/DSCF6381_ENTREGAJUANSANCHEZ.46f16cd9.jpg";